import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import './ManageEmailTemplates.css';

const ManageEmailTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEmailTemplates();
  }, []);

  const fetchEmailTemplates = async () => {
    try {
      setLoading(true);
      const data = await apiService.get('/email-template');
      setTemplates(Array.isArray(data) ? data : []);
      setError(null);
    } catch (err) {
      console.error('Error fetching email templates:', err);
      setError('Failed to load email templates. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Email Templates</h1>
        </div>
        <div className="loading-state">
          <p>Loading email templates...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Email Templates</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchEmailTemplates} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Email Templates</h1>
        {templates.length > 0 && (
          <div className="pagination-info">
            Showing {templates.length} email template{templates.length !== 1 ? 's' : ''}
          </div>
        )}
      </div>

      <div className="properties-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Email Subject</th>
              <th>Last Updated</th>
              <th>Last Updater</th>
            </tr>
          </thead>
          <tbody>
            {templates.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '40px' }}>
                  No email templates found
                </td>
              </tr>
            ) : (
              templates.map((template) => (
                <tr 
                  key={template.id}
                  onClick={() => navigate(`/email-templates/${template.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <td>
                    <strong>{template.id}</strong>
                  </td>
                  <td>
                    <a 
                      href="#"
                      className="property-link"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate(`/email-templates/${template.id}`);
                      }}
                      title="Click to edit email template"
                    >
                      {template.title || 'N/A'}
                    </a>
                  </td>
                  <td>{template.emailSubject || 'N/A'}</td>
                  <td>{formatDate(template.lastUpdated)}</td>
                  <td>{template.lastUpdater || 'N/A'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageEmailTemplates;

